import { Component, OnInit, Inject, Input, ElementRef, ViewChild, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { WindowState } from '@progress/kendo-angular-dialog';
import { LazyLoadingLibraryService } from '~/modules/stocks/reports/report/LazyLoadingLibraryService';
import { SharedService } from '~/services/sharedService';
import { LayoutManagerService, PORTAL_DATA } from '../../layout/layout-manager';
import { LabelService } from '~/services/modules/stocks/labels';
import { ThemeManagerService } from '~/services/theme-manager';
declare const JsBarcode: any; // Declare JsBarcode
@Component({
    selector: 'app-barcode-print',
    templateUrl: './barcode-print.component.html',
    styleUrls: ['./barcode-print.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarcodePrintComponent implements OnInit {
  windowState: WindowState ='default';

  windowMode: boolean = true;
  _active: boolean;
  previewMode: boolean = true;
  maximized: boolean;
  _previewBarcodeWindow: boolean = false;
  barcodeModel = {
    BarcodeValues: [{BarcodeNumber:'00002'}],
        LabelSizeID: 1,
        Row: 1,
        Column: 1,
        LabelSize: {},
        numberOfCopy: 1
  };
  viewBarcode: boolean = false
  reportFileLoaded = false;
  viewerFileLoaded = false;
  designerFileLoaded = false;
  viewer: any;
  stimulsoftReport: any;
  public dataSet: any;
  showPreviewButton: boolean = false;
  _theme: string;
  @Input() page: string;
  @Input() BarcodeValue: any;
  @ViewChild('barcodeContainer') barcodeContainer: ElementRef;
  constructor(
      private _sharedService: SharedService,
      private _labelsService: LabelService,
      private _layoutManager: LayoutManagerService,
      private elementRef: ElementRef,
      private _lazyLoadingLibraryService: LazyLoadingLibraryService,
      private _themeManager: ThemeManagerService,
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

  }

  ngOnInit(){

  }
  ngAfterViewInit()
  {
this._lazyLoadingLibraryService
.loadJs('assets/scripts/JsBarcode.all.min.js')
.subscribe((x: any) => {
   this.reportFileLoaded = true;
   this._labelsService.getPrintPreferenceByPage(this.page)
   
   .subscribe((printPreference: any) => {
     if(printPreference && printPreference.data.labelSizeId)
     this._labelsService.getLabelSizeById(printPreference.data.labelSizeId).subscribe((labelSize: any) => {
       this.barcodeModel = {
         BarcodeValues: [{BarcodeNumber: this.BarcodeValue}],
         LabelSizeID: printPreference.data.labelSizeI,
         Row: 1,
         Column: 1,
         LabelSize: labelSize,
         numberOfCopy: 1
       }
       this.loadBarcodeIcon();
     });
   });


});




  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.BarcodeValue.previousValue) {
      this.barcodeModel.BarcodeValues = [{BarcodeNumber: this.BarcodeValue}],
        this.loadBarcodeIcon();

    }
}

  loadBarcodeIcon()
  {
//     //  // Generate the barcode using the JsBarcode library
//     //  JsBarcode(this.barcodeContainer.nativeElement, '123456789', {
//     //   format: 'CODE128',
//     //   displayValue: false,
//     //   width: 2,
//     //   height: 60,
//     // });

//     let divDOM = document.getElementById("BarcodeId");
//     if(divDOM && divDOM.innerHTML)
//     divDOM.innerHTML = '';
// let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
// svg.setAttribute('jsbarcode-format', 'CODE128');
// svg.setAttribute('jsbarcode-value', this.BarcodeValue);
// // svg.setAttribute('width', '200');
// // svg.setAttribute('height', '100');
// svg.className.baseVal = "barcodePrint";
// if(divDOM)
// {
//   //divDOM.appendChild(svg);

//   JsBarcode(".barcodePrint", this.BarcodeValue,{
//       format: 'CODE128',
//       displayValue: false,
//       width: 1,
//       height: 40}
//     ).init();

    this.viewBarcode = true;
    this.showPreviewButton = true;
}



  _onCancel() {
    this._closeForm();
}

_closeForm() {
    var closeComponent = {
      component : 'reportViewer',
      isClosed : true
    }
    this._previewBarcodeWindow = false;
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
}

maximizeWindow()
{
    this.windowState = 'maximized';
    this.maximized = true;
}

ngOnDestroy() {
    this._layoutManager.removeOverlay();
}

_onStateChanges(e: any) {
    if (e === 'minimized') {
        this._layoutManager.removeOverlay();
    } else {
        this._layoutManager.applyOverly();
    }
}
previewBarcode(){
  this._previewBarcodeWindow = true;
}
  // public Barcode_PrePrintBarcodes(BarcodeValues: any[], LabelSizeID: number, Row: number, Column: number, LabelPresetId : number = null, LabelSize: any, NumberOfCopies: number)
  // {
  //   if(!NumberOfCopies)
  //   NumberOfCopies = 1;
  //     let isQR =  false;

  //         let columnWidth: number;
  //         this.stimulsoftReport.reportUnit = Stimulsoft.Report.StiReportUnitType.Inches // Inches
  //         let page =this.stimulsoftReport.pages.getByIndex(0);

  //         if (LabelPresetId == null)
  //         {

  //             let _Width = LabelSize.width;
  //             let _Height = LabelSize.height;

  //             let _PageWidth = LabelSize.pageWidth;
  //             let _PageHeight =LabelSize.pageHeight;
  //             let VerticalPitch = LabelSize.verticalPitch;
  //             let VerticalMargin = LabelSize.verticalMargin;
  //             let HorizontalMargin = LabelSize.horizontalMargin;
  //             let Columns = LabelSize.columns;
  //             let Rows = LabelSize.rows;
  //              page.margins.left = LabelSize.pageLeftMargin;
  //              page.margins.bottom =  LabelSize.pageBottomMargin;
  //              page.margins.right =  LabelSize.pageRightMargin;
  //             page.margins.top = VerticalMargin;
  //             page.unlimitedHeight = false;

  //             page._pageWidth =_PageWidth;
  //             page._pageHeight = _PageHeight;
  //             page.pageWidth =_PageWidth;
  //             page.pageHeight = _PageHeight;

  //             page._numberOfCopies = NumberOfCopies;
  //             columnWidth = _Width;

  //             let ds = new Stimulsoft.System.Data.DataSet('DataSet');

  //            this.dataSet.readJson(BarcodeValues as Array<any>);
  //            this.stimulsoftReport.regData(this.dataSet.dataSetName, '', this.dataSet);
  //            this.stimulsoftReport.dictionary.synchronize();

  //              let Zebra = false;

  //             if (LabelSizeID >= 11 && LabelSizeID < 22)
  //                 Zebra = true;
  //             if(!LabelSizeID)
  //             {
  //               Zebra = true;
  //             }


  //                 page.margins.top = 0;
  //                 //Create Databand
  //                 let dataBand = new Stimulsoft.Report.Components.StiDataBand();
  //                 let pos = 0;
  //                 let posY = 0;
  //                 let dbHeight = 0;
  //                 dbHeight = VerticalPitch;
  //                 columnWidth = Math.round(columnWidth);
  //                 posY = posY + 0.2;
  //                 let rectX = 0;
  //                   for (let i = 0; i < BarcodeValues.length; i++){

  //                     dataBand = new Stimulsoft.Report.Components.StiDataBand(new Stimulsoft.Base.Drawing.RectangleD(0, 0, _Width, _Height));
  //                     dataBand.name = "DataBand";
  //                     page.components.add(dataBand);



  //                     let rectY = 0;
  //                     let BarcodeHeight = _Height;


  //                      if(LabelSizeID == 15)//Zebra 1.5x0.5
  //                     {
  //                         rectX = -0.2;

  //                     }


  //                      else if(LabelSizeID == 19) // Zebra 1.25x1
  //                     {
  //                       rectX = 0.1;

  //                     }


  //                     let CodeHeight = _Height;

  //                     let Barcode1 = new Stimulsoft.Report.BarCodes.StiBarCode(new Stimulsoft.Base.Drawing.RectangleD(rectX, rectY, columnWidth, _Height));
  //                     Barcode1.codeValue = BarcodeValues[i].BarcodeNumber.toString();


  //                     if (!isQR)
  //                     {
  //                         Barcode1.horAlignment = Stimulsoft.Base.Drawing.StiHorAlignment.Center;
  //                         Barcode1.vertAlignment = Stimulsoft.Base.Drawing.StiVertAlignment.Center;


  //                         if(LabelSizeID == 14 || LabelSizeID == 15 || LabelSizeID == 19)
  //                         {

  //                         BarcodeHeight = 0.2;

  //                         }
  //                         if(!LabelSizeID)
  //                           BarcodeHeight = _Height;
  //                         // else
  //                          Barcode1.autoScale = false;
  //                         Barcode1.showLabelText = true;

  //                         Barcode1.barCodeType = new Stimulsoft.Report.BarCodes.StiCode128AutoBarCodeType(10, BarcodeHeight);
  //                     }


  //                     dataBand.components.add(Barcode1);
  //                     posY = (posY + _Height / 2) - 0.2;

  //                     this.stimulsoftReport.pages.getByIndex(0).orientation =  Stimulsoft.Report.Components.StiPageOrientation.Portrait;
  //                   }
  //                 //}


  //         }



  //         this.viewer.report = this.stimulsoftReport;
  //         this.viewer.renderHtml('viewer');
  // }

}
